const surveyModal = payload => {
  return {
    type: "changesurvey",
    payload
  };
};

export default surveyModal;
